<div class="open-raptor-price-cards-container" [ngClass]="[componentDetails?.settings?.class || '', 'is-' + componentDetails?.settings?.type]">
  <div class="open-raptor-price-cards">

    <ng-container *ngFor="let card of cards">

      <div class="open-raptor-price-card" *ngIf="card?.cover && raptorDataService.isCoverVisible(card?.cover, formData, form)">
      
        <div class="open-raptor-price-card-offers">
          <div class="open-raptor-price-card-offer" *ngFor="let offer of card.offers">
            <ng-container [ngSwitch]="offer?.type">
              <strong>{{ offer?.text }}</strong>
              <ng-container *ngSwitchCase="'help'">
                <open-tooltip [tooltipIcon]="offer?.icon" [tooltipContent]="offer?.content"></open-tooltip>
              </ng-container>        
              <ng-container *ngSwitchDefault>
                <mat-icon [ngClass]="offer?.icon" aria-hidden="false" [attr.aria-label]="offer?.text"></mat-icon>
              </ng-container>
            </ng-container> 
          </div>
        </div>

        <div class="open-raptor-price-card-details">          
          <div class="open-raptor-price-card-price">
            <h3 class="open-raptor-price-card-title margin-bottom-small">{{ card?.title || card?.cover?.label }}</h3>

            <div class="open-raptor-price-card-discount strong-small" *ngIf="(raptorPriceService.getCoverDiscount(card?.cover, frequency, currency, currencySymbol) | keyvalue)?.length && (card?.initialPrice || card?.discountAmount)">
              <span *ngIf="card?.initialPrice">Was <s>{{ raptorPriceService.getCoverDiscount(card?.cover, frequency, currency, currencySymbol).amount }}</s></span><open-badge *ngIf="card?.discountAmount" [label]="raptorPriceService.getCoverDiscount(card?.cover, frequency, currency, currencySymbol).saving" [variant]="'decorative'" [size]="'small'"></open-badge>
            </div>

            <open-price class="font-700" [price]="raptorPriceService.getCoverPrice(card?.cover, frequency, currencySymbol)" size="large" [smallerDecimal]="true"></open-price>
            
            <div class="strong-small" *ngIf="frequency !== 'U' && raptorPriceService.getArrangFee(card?.cover).is_included">
              For 11 months, first month {{ currencySymbol }}{{ raptorPriceService.getFirstMonthCoverPrice(card?.cover).amount }}*
            </div>

            <div class="text-small" *ngIf="frequency !== 'U' && componentDetails?.settings?.showTotalPrice">
              Total {{ currencySymbol }}{{ raptorPriceService.getYearlyCoverPrice(card?.cover).amount }}
            </div>
          </div>

          <button *ngIf="card?.cta?.enabled" mat-flat-button color="primary" type="button" class="width-full" (click)="submitCover(card?.cover)" [disabled]="raptorStepService.loading">
            <span class="mdc-button__label" *ngIf="!raptorStepService.loading">Select</span>
            <mat-spinner *ngIf="raptorStepService.loading" diameter="28"></mat-spinner>
          </button> 

          <div class="open-raptor-price-card-social-proof" *ngIf="card?.socialProof?.enabled">
            <open-social-rating [componentDetails]="card?.socialProof"></open-social-rating>
          </div>
        </div>

      </div>
    </ng-container>
  </div>
</div>
